import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { getPrimaryImage } from "~/utils/product/getPrimaryImage";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";
import { IMG_MISSING_PRODUCT } from "~/utils/url/staticResources";
import { useForcedConfiguratorTranslations } from "~/features/configurator/common/useXmlConfiguratorTranslations";
import {
  type ConfiguratorProductData,
  isConfiguratorProduct,
  type ProductData,
} from "~/domains/product/types/ProductData";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { RAIL_CONFIGURATOR_PRODUCT_CODE } from "~/domains/configurator/constants";
import { Suspense } from "react";

interface Props extends BaseProductElementProps {
  clickable?: boolean;
  linkProps?: JSX.IntrinsicElements["a"];
  width?: number;
  height?: number;
}

function isNewTypeConfiguratorProduct(product: ProductData): product is ConfiguratorProductData {
  return (
    isConfiguratorProduct(product) &&
    (product.configuratorType === ConfiguratorType.MetricShaft ||
      product.configuratorType === ConfiguratorType.InchShaft)
  );
}

const PrimaryImageInner = (props: Props) => {
  const { clickable = true, linkProps } = props;

  const product = useProductContext(props);
  // TODO - Fix this so it doesn't have to use the rail configurator product code
  const xmlT = useForcedConfiguratorTranslations(
    isConfiguratorProduct(product) ? product.code : RAIL_CONFIGURATOR_PRODUCT_CODE,
  )?.t;

  let imageUrl = IMG_MISSING_PRODUCT;
  const image = getPrimaryImage(product, { imageFormat: "thumbnail" });
  if (image) {
    if (isNewTypeConfiguratorProduct(product)) {
      imageUrl = xmlT?.(image.url) ?? image.url;
    } else {
      imageUrl = image.url;
    }
  }
  const pdpUrl = useProductDetailsUrl(product);

  let imageCmp = <img className={props.className} src={imageUrl} alt={image?.altText} {...props} />;
  if (clickable) {
    imageCmp = (
      <a href={pdpUrl} className={props.className} {...linkProps}>
        {imageCmp}
      </a>
    );
  }

  return imageCmp;
};

export const PrimaryImage = (props: Props) => {
  return (
    <Suspense fallback={null}>
      <PrimaryImageInner {...props} />
    </Suspense>
  );
};
